/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DocumentSasUrlDto } from '../models/document-sas-url-dto';
import { getBillableServicesDocumentProof } from '../fn/billable-service-proof-document-controller/get-billable-services-document-proof';
import { GetBillableServicesDocumentProof$Params } from '../fn/billable-service-proof-document-controller/get-billable-services-document-proof';


/**
 * Create proof document billable services.
 */
@Injectable({ providedIn: 'root' })
export class BillableServiceProofDocumentControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getBillableServicesDocumentProof()` */
  static readonly GetBillableServicesDocumentProofPath = '/customers/{customerId}/billable-services/document/proof';

  /**
   * Get billable services proof document for customer.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getBillableServicesDocumentProof()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBillableServicesDocumentProof$Response(params: GetBillableServicesDocumentProof$Params, context?: HttpContext): Observable<StrictHttpResponse<DocumentSasUrlDto>> {
    return getBillableServicesDocumentProof(this.http, this.rootUrl, params, context);
  }

  /**
   * Get billable services proof document for customer.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getBillableServicesDocumentProof$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getBillableServicesDocumentProof(params: GetBillableServicesDocumentProof$Params, context?: HttpContext): Observable<DocumentSasUrlDto> {
    return this.getBillableServicesDocumentProof$Response(params, context).pipe(
      map((r: StrictHttpResponse<DocumentSasUrlDto>): DocumentSasUrlDto => r.body)
    );
  }

}
